// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__loVOT","modal__title":"styles_modal__title__eHaoU","modal__footer":"styles_modal__footer__SWPvY"};